import { AssumptionStore } from '@migrate/components/navigator/stores/AssumptionStore'
import { IFormField, validateFormField } from '@migrate/utils/form/form'
import { action, makeObservable } from 'mobx'
import i18n from 'i18next'
import UserNotificationStore, { UserNotificationType } from '@migrate/stores/UserNotificationStore'
import { stores } from '@migrate/stores'
import { AssumptionValue, EntityAssumptionDetail } from '@portal/pkg-api/gen/navigator'
import { AssumptionApi } from '@portal/pkg-api/navigator'

export default class EditAssumptionStore extends AssumptionStore {
  editField: IFormField | null = null

  constructor() {
    super()

    makeObservable(this)
  }

  @action
  startEditing(field: IFormField) {
    // if something prior was being edited but somehow not closed...
    if (this.editField && this.editField.id !== field.id) {
      this.editField.state.editing = false
      this.editField = null
    }

    if (!this.editField) {
      field.state.editing = true
      field.state.startEditValue = field.value
      field.state.startEditSelectValue = field.meta.value2
      this.editField = field
    }
  }

  @action
  async stopEditing(field: IFormField, value: any) {
    // Unions need special handling
    if (field.meta.model?.assumption?.type === 'union') {
      this.stopEditingUnion(field.value)
      return
    }

    // don't update if nothing has changed, for some items the value2 might have changed
    // and the value didn't. Ensure that one or the other or both have changed
    if (
      field.state.startEditValue === value &&
      (field.state.startEditSelectValue
        ? field.state.startEditSelectValue === field.meta.value2
        : true)
    ) {
      field.state.editing = false
      this.editField = null
      return
    }

    field.value = value

    if (!validateFormField(field)) {
      return
    }

    field.state.editing = false
    this.editField = null

    this.fieldAssumptionProcessor.updateConditionals()
    await this.handlePostEdit(field)
    this.afterUpdateConditionals()
  }

  @action
  setAssumptionValue(field: IFormField, value: any) {
    field.value = value
    this.fieldAssumptionProcessor.updateConditionals()
    validateFormField(field)
    this.afterUpdateConditionals()
  }

  @action
  async setAssumptionValue2(field: IFormField, value: string) {
    field.meta.value2 = value
    await this.handlePostEdit(field)
  }

  @action
  setAssumptionEditValue(field: IFormField, value: any) {
    field.state.editValue = value
    this.fieldAssumptionProcessor.updateConditionals()
    validateFormField(field)
    this.afterUpdateConditionals()
  }

  @action
  async handlePostEdit(_field: IFormField) {}

  @action
  stopEditingUnion(assumption: EntityAssumptionDetail) {
    assumption!.union!.unionNamedRanges!.forEach((namedRange: any) => {
      const assumptionValue: AssumptionValue = {
        id: namedRange.id,
        entityId: namedRange.entityId,
        assumptionId: namedRange.assumption!.id,
        value: namedRange.value,
      }

      try {
        if (!assumptionValue.id) {
          AssumptionApi.createAssumptionValue(assumptionValue).then()
        } else {
          AssumptionApi.saveAssumptionValue(assumptionValue.id, assumptionValue).then()
        }
      } catch (e) {
        const errorText = i18n.t('navigator.detail.errorSaving')
        const notificationStore: UserNotificationStore = stores[UserNotificationStore.STORE_NAME]
        if (notificationStore) {
          notificationStore.addNotification(UserNotificationType.ERROR, errorText)
        }
        console.error(errorText, e)
      }
    })
  }

  @action
  afterUpdateConditionals() {}
}
